import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import './css/layout.scss';
import App from './App';
import 'Tools/loadingFonts';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
